module.exports = __webpack_public_path__ + "media/ssta_rotation.dbcee574.mp4";